import React from 'react'
import { getFileAsset } from '@sanity/asset-utils'
import { VscFilePdf } from 'react-icons/vsc'

const RtFile = ({ value: { file } }) => {
	const { url } = getFileAsset(file.file, {
		projectId: process.env.GATSBY_SANITY_PROJECT_ID,
		dataset: process.env.GATSBY_SANITY_DATASET,
	})

	return (
		<p>
			<a className="link text-orange with-icon" href={url} target="_blank">
				<VscFilePdf className="text-xl" />
				{file.name}
			</a>
		</p>
	)
}

export default RtFile
